import { apiHostname, SUPPORTED_PORTAL_CURRENCIES } from 'shared/constants';
import { GenericThunk } from './shared/createGenericStoreSlice';

export const changeUserCurrency =
  (currency: SUPPORTED_PORTAL_CURRENCIES): GenericThunk =>
  async (dispatch, getState, httpClient) => {
    await httpClient.put(`${apiHostname}/api/me/currency`, { currency });
  };
